import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { Component, ViewChild, Output, EventEmitter, ElementRef, Input, OnInit } from '@angular/core';
import { NavController, NavParams, ModalController, ToastController, Slides, ViewController, AlertController, MenuController, App } from 'ionic-angular';
import { AngularFirestore, AngularFirestoreDocument } from 'angularfire2/firestore';
import * as $ from 'jquery';
import firebase from 'firebase/app';
import { AngularFireAuth } from 'angularfire2/auth';
import { Http, Headers, RequestOptions } from '@angular/http';
import { LoadingProvider } from '../../../../../providers/loading/loading';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { ViewContactPage } from '../../../../view-contact/view-contact';
import { HomePage } from '../../../../home/home';
import { SdfFormService } from '../../../../../app/services/sdf-form-service';
import { AngularFireStorage } from 'angularfire2/storage';
import { fromEvent, from } from 'rxjs';
import { debounceTime, take } from "rxjs/operators";
import { EnvDataService } from '../../../../../app/services/env-data-service';
import { DataService } from "../../../services/data.service";
declare var google;
@Component({
  selector: 'adf-additional-contact-form',
  templateUrl: 'additional-contact.html',
  providers: [EnvDataService]
})
export class AdditionalContact implements OnInit {
  @Input() editdata: any;

  additionalForm: FormGroup;

  userRole: any;
  new_val: any;
  old_val: any;
  applicant_details: any;
  allBrokers: any;
  applicant_type: any;
  dateMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  SDF_form_document_id: any;
  primary_uid: any;
  edit_contact_uid: any;
  deleted_access: any;
  firstname1: any;
  public indexx: number;
  public secondary_uid: any;

  public validation_messages = {
    'secondary_firstname': [
      { type: 'required', message: 'Firstname is required.' }
    ],
    'secondary_lastname': [
      { type: 'required', message: 'Lastname is required.' }
    ],
    'secondary_email': [
      { type: 'required', message: 'Email is required.' }
    ],
    'secondary_mobile_phone': [
      { type: 'required', message: 'Mobile Number is required.' },
      { type: 'minlength', message: 'Mobile Number must be at least 10 digit long.' },
      { type: 'maxlength', message: 'Mobile Number must be at least 10 digit long.' }
    ],
    'secondary_date_of_birth': [
      { type: 'required', message: 'Date of Birth is required.' }
    ],

  }

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public db: AngularFirestore,
    public alertCtrl: AlertController,
    public loadingProvider: LoadingProvider,
    public SdfFormService: SdfFormService,
    private DataService: DataService
  ) {
    this.userRole = window.localStorage.getItem("userRole");
    this.applicant_details = '';
    this.getAllBrokers().subscribe((data) => {
      this.allBrokers = data;
    });
    this.applicant_type = "Primary";
    this.SDF_form_document_id = this.navParams.get("SDF_form_document_id");
    let thiss = this;
    this.secondary_uid = [];

    this.additionalForm = formBuilder.group({
      firstname: ['', Validators.compose([Validators.maxLength(30), Validators.minLength(1), Validators.required])],
      middlename: ['', Validators.compose([Validators.maxLength(30)])],
      lastname: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      email: ['', Validators.compose([Validators.required, Validators.email, Validators.minLength(10), Validators.required])],
      mobile_phone: ['', Validators.compose([Validators.minLength(12), Validators.maxLength(12), Validators.required])],
      date_of_birth: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary: ['', Validators.compose([Validators.maxLength(30)])],
      reference_broker: [''],
      user_document_id: [''],
      addAnotherApplicantItem: this.formBuilder.array([]),
      addAddressRelationshipItem: this.formBuilder.array([])
    });

    
  }
  ngOnInit() {

   
  }


  get formArrApplicantAddress() {
    return this.additionalForm.get('addAddressRelationshipItem') as FormArray;
  }

  get formPreviousAddress() {
    return this.additionalForm.get('addPreviousAddressItem') as FormArray;
  }

  ngOnChanges() {
  
  
  }

  additionaldata(thiss) {
    this.SdfFormService.get_second_user_data(thiss.SDF_form_document_id)
      .then((get_second_user_data) => {
        Object.keys(get_second_user_data).forEach(function (key) {
          thiss.secondary_uid.push({ 'secondary_uid': get_second_user_data[key].uid, 'document_id': get_second_user_data[key].document_id })
          var secondUser = firebase.firestore().collection("users").doc(get_second_user_data[key].uid);
          secondUser.get().then(function (secdoc) {
            get_second_user_data[key].email = secdoc.data().email;
            get_second_user_data[key].mobile_phone = secdoc.data().mobile_phone;
            thiss.formApplicant.push(thiss.initItemRowsApplicantLoad(get_second_user_data[key]));
           
          });
        })
      }, (err) => {
     
      })
  }

  initItemRowsApplicantLoad(data) {
    return this.formBuilder.group({
      secondary_firstname: [data.firstname, Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_middlename: [data.middlename, Validators.compose([Validators.maxLength(30)])],
      secondary_lastname: [data.lastname, Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_email: [data.email, Validators.compose([Validators.maxLength(100), Validators.required])],
      secondary_mobile_phone: [data.mobile_phone, Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_date_of_birth: [data.date_of_birth, Validators.compose([Validators.maxLength(30), Validators.required])],
      relationship_to_primary_applicant: [(data.relationship_to_primary_applicant == "" || data.relationship_to_primary_applicant == null || data.relationship_to_primary_applicant == undefined) ? 'Life Partner' : data.relationship_to_primary_applicant, Validators.compose([Validators.maxLength(100), Validators.required])],
      deleted: [0],
      uid: [data.uid],
      document_id: [data.document_id]
    });
  }

  addAnotherApplicant() {
  
    this.DataService.changeaddanotherApplicant();
    this.indexx = this.formApplicant.length - 1;
  }


  deleteSecondaryApplicant(index){

    this.formArrApplicantAddress.removeAt(index);
  }

  initaddAnotherApplicant() {
    return this.formBuilder.group({
    
      secondary_firstname: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_middlename: ['', Validators.compose([Validators.maxLength(30)])],
      secondary_lastname: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_email: ['', Validators.compose([Validators.maxLength(100), Validators.required])],
      secondary_mobile_phone: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      secondary_date_of_birth: ['', Validators.compose([Validators.maxLength(30), Validators.required])],
      relationship_to_primary_applicant: ['Life Partner', Validators.compose([Validators.maxLength(30), Validators.required])],
      deleted: [0],
      uid: [''],
      document_id: ['']
    });
  }

  editgetSDFUser(SDF_form_document_id, uid) {
    if (this.userRole == "super_admin" && this.deleted_access == 1) {
      return this.db.collection<any>("users_data", ref => ref.where('created_date', '>', 0).where('SDF_form_document_id', '==', SDF_form_document_id).where('uid', '==', uid).orderBy('created_date', 'asc')).valueChanges();
    } else {
      return this.db.collection<any>("users_data", ref => ref.where('created_date', '>', 0).where('SDF_form_document_id', '==', SDF_form_document_id).where('uid', '==', uid).where('deleted', '==', 0).orderBy('created_date', 'asc')).valueChanges();
    }
  }

  getAllBrokers() {
    return this.db.collection<any>("users", ref => ref.where('roles.broker', '==', true)).valueChanges();
  }
  get formApplicant() {
    return this.additionalForm.get('addAnotherApplicantItem') as FormArray;
  }



  changeLog(event, index: any) {
    debugger;
    console.log(index)
  }
  collectLogData(event, type, index) {

  }


}




// WEBPACK FOOTER //
// ./src/pages/adf-page/component/primary-applicant/additional-contact/additional-contact.ts